exports.install = function(Vue, options) {

  //通过Code得到IndustryName
  Vue.prototype.industryName = function(code) {
    if (this.$store.state.configData &&
      this.$store.state.configData.industries) {
      var names = this.$store.state.configData.industries.filter(item => code === item.guid)
      if (names && names.length > 0)
        return names[0].name;
    }
  };
  Vue.prototype.z_industryName = function(code) {
    if (this.$store.state.configData &&
      this.$store.state.configData.industries) {
      var names = this.$store.state.configData.industries.filter(item => code === item.guid)
      if (names && names.length > 0)
        return names[0].name;
    }
  };
  //去除字符串前后空格
  Vue.prototype.trimStr = function(str) {
    return str.replace(/(^\s*)|(\s*$)/g, "")
  };
  Vue.prototype.success = function(message, ...optionalParams) {
    // .success(message, ...optionalParams);
    this.Allmodel(message, null, 1)
  };
  Vue.prototype.error = function(message, ...optionalParams) {
    // console.error(message, ...optionalParams);
    this.Allmodel(message, null, 2)
  };
  Vue.prototype.debug = function(message, ...optionalParams) {
    // console.log(message, ...optionalParams);
    this.Allmodel(message, null, 3)
  };
  Vue.prototype.info = function(message, ...optionalParams) {
    // console.info(message, ...optionalParams);
    this.Allmodel(message, null, 3)
  };
  Vue.prototype.warn = function(message, ...optionalParams) {
    // console.warn(message, ...optionalParams);
    this.Allmodel(message, null, 4)
  };
  Vue.prototype.industryNames = function(codes) {
    //判断是数组时，再执行
    if (!codes) return
    if (codes instanceof Array) {
      if (this.$store.state.configData &&
        this.$store.state.configData.industries) {
        return codes.map(code => {
          return this.industryName(code)
        })
      }
    } else {
      this.warn("this.industryNames params is not array", codes);
    }
  };
  //通过国家编号获取国家名称
  Vue.prototype.countryName = function(code) {
    if (this.$store.state.configData &&
      this.$store.state.configData.countries) {
      var names = this.$store.state.configData.countries.filter(item => code === item.guid)
      if (names && names.length > 0)
        return names[0].cname;
    }
  };
  //通过地区编号获取地区名称
  Vue.prototype.regionName = function(code) {
    if (this.$store.state.configData &&
      this.$store.state.configData.regions) {
      var names = this.$store.state.configData.regions.filter(item => code === item.guid)
      if (names && names.length > 0)
        return names[0].name;
    }
  };
  Vue.prototype.regionNames = function(codes) {
    if (!codes) return;
    //传入数组时执行
    if (codes instanceof Array) {
      if (!codes || codes.length == 0)
        return null;
      if (this.$store.state.configData &&
        this.$store.state.configData.regions) {
        return codes.map(code => {
          return this.regionName(code)
        })
      }
    } else {
      this.warn("this.regionNames params is not array", codes);
    }
  };
  //通过职能编号获取职能名称
  Vue.prototype.functionName = function(code) {
    if (this.$store.state.configData &&
      this.$store.state.configData.functions) {
      var names = this.$store.state.configData.functions.filter(item => code === item.guid)
      if (names && names.length > 0)
        return names[0].name;
    }
  };
  //通过职能编号获取职能名称2
  Vue.prototype.getFunctionName = function(code) {
    if (this.$store.state.configData &&
      this.$store.state.configData.functions) {
      var names = this.$store.state.configData.functions.filter(item => code === item.guid)
      if (names && names.length > 0)
        return names[0].name;
    }
  };
  Vue.prototype.functionNames = function(codes) {
    //传入数组时执行
    if (!codes) return
    if (codes instanceof Array) {
      if (codes.length > 0) {
        if (this.$store.state.configData &&
          this.$store.state.configData.functions) {
          return codes.map(code => {
            return this.functionName(code)
          })
        }
      }
    } else {
      this.warn("this.functionNames params is not array", codes);
    }

  };
  Vue.prototype.formatWorkYearRequirment = function(theWorkYearMin, theWorkYearMax) {
    if (!theWorkYearMin && !theWorkYearMax) {
      return null;
    }
    var name;
    if (theWorkYearMin && !theWorkYearMax) {
      name = theWorkYearMin + "年以上";
    } else if (!theWorkYearMin && theWorkYearMax) {
      name = theWorkYearMax + "年以下";
    } else {
      if (theWorkYearMin == theWorkYearMax) {
        return theWorkYearMin + "年";
      }
      name = theWorkYearMin + "~" + theWorkYearMax + "年";
    }
    return name;
  };
  Vue.prototype.formatAgeRequirment = function(theAgeMin, theAgeMax) {
    var name;
    if (!theAgeMin && !theAgeMax) {
      return null
    }
    if (!theAgeMin && theAgeMax) {
      name = theAgeMax + "岁以下";
    } else if (theAgeMin && !theAgeMax) {
      name = theAgeMin + "岁以上";
    } else if (theAgeMin && theAgeMax) {
      if (theAgeMin == theAgeMax) {
        name = theAgeMin + "岁";
        return name
      }
      name = theAgeMin + "岁~" + theAgeMax + "岁";
    }
    return name
  };
  Vue.prototype.formatSexRequirment = function(sex) {
    if (sex == "Male") {
      return "男";
    } else if (sex == "Female") {
      return "女";
    }
    return null;
  };
  Vue.prototype.formatMaritalRequirment = function(marital) {
    if (marital) {
      if (marital == "Married") {
        return "已婚";
      } else if (marital == "MarriedWithChild") {
        return "已婚已育";
      } else if (marital == "MarriedNoChild") {
        return "已婚未育";
      } else if (marital == "Unmarried") {
        return "未婚";
      } else if (marital == "Secrecy") {
        return "保密";
      } else {
        return "不限";
      }
    }
    return null
  };
  Vue.prototype.strToInt = function(strValue) {
    if (!strValue) return strValue;
    if (strValue instanceof String) {
      return parseInt(strValue);
    }
    return strValue
  };
  //去除左空格
  Vue.prototype.leftTrim = function(str) {
    return str.replace(/(^\s*)/g, "")
  }
  //去掉右空格
  Vue.prototype.rightTrim = function(str) {
    return str.replace(/(\s*$)/g, "")
  }
  //去除字符串前后空格
  Vue.prototype.trimStr = function(str) {
    return str.replace(/(^\s*)|(\s*$)/g, "")
  }
  Vue.prototype.formatYearSalaryRequirment = function(theYearSalaryMin, theYearSalaryMax) {
    var name;
    if (!theYearSalaryMin && !theYearSalaryMax) {
      return null;
    }
    if (theYearSalaryMin && !theYearSalaryMax) {
      name = theYearSalaryMin + "万元以上";
    } else if (!theYearSalaryMin && theYearSalaryMax) {
      name = theYearSalaryMin + "万元以下";
    } else if (theYearSalaryMin == theYearSalaryMax) {
      name = theYearSalaryMin + "万元";
      return name;
    } else {
      name =
        theYearSalaryMin +
        "~" +
        theYearSalaryMax +
        "万元";
    }
    return name;
  };
  Vue.prototype.formatYear = function(date) {
    if (date) {
      return new Date(date).format('yyyy/MM');
    } else {
      return '至今';
    }
  };
  Vue.prototype.formatDate = function(date) {
    if (date) {
      return new Date(date).format("yyyy-MM-dd");
    }
  };
  //只要月份和日期
  Vue.prototype.formatMonthTime = function(date) {
    if (date) {
      return new Date(date).format("MM-dd");
    }
  };
  //只要小时和分钟
  Vue.prototype.formatHourTime = function(date) {
    if (date) {
      return new Date(date).format('hh:mm');
    }
  };
  Vue.prototype.formatDateTime = function(date) {
    if (date) {
      return new Date(date).format("yyyy-MM-dd hh:mm:ss");
    }
  };
  Vue.prototype.formatRefreshAfterRequirment = function(refreshAfter) {
    if (refreshAfter == "ThreeDay") {
      return "三天内";
    } else if (refreshAfter == "Weekend") {
      return "一周内";
    } else if (refreshAfter == "HalfMonth") {
      return "半月内";
    } else if (refreshAfter == "Month") {
      return "一月内";
    } else {
      return null;
    }
  };
  //通过degree.eName得到degree.cName
  Vue.prototype.degreescName = function(eName) {
    if (this.$store.state.configData &&
      this.$store.state.configData.degrees) {
      var degrees = this.$store.state.configData.degrees.filter(item => eName === item.eName)
      if (degrees && degrees.length > 0)
        return degrees[0].cName;
    }
  };
  // 分布统计图中degreesDiscName.degreesDiscName.cName
  Vue.prototype.degree_levelCName = function(eName) {
    if (this.$t("degree_level")) {
      var degree_level = this.$t("degree_level").filter(item => eName === item.eName)
      if (degree_level && degree_level.length > 0)
        return degree_level[0].cName;
    }
  };
  // 分布统计图中degreesDiscName.degreesDiscName.cName
  Vue.prototype.year_salary_levelCName = function(eName) {
    if (this.$t("year_salary_level")) {
      let levels = this.$t("year_salary_level").filter(item => eName === item.eName);
      if (levels && levels.length > 0) {
        return levels[0].cName;
      }
    }
  };

  // 分布统计图中workExperice_level.cName
  Vue.prototype.workExperice_levelcName = function(eName) {
    if (this.$t("workExperice_level")) {
      let levels = this.$t("workExperice_level").filter(item => eName === item.eName);
      if (levels && levels.length > 0) {
        return levels[0].cName;
      }
    }
  };

  //国际化数据来源 gBcompanyTypescName.gBcompanyTypescName.cName
  Vue.prototype.gBcompanyTypescName = function(eName) {
    var companyTypes = this.$t("companyTypes")
    if (companyTypes) {
      companyTypes = this.$t("companyTypes").filter(item => eName === item.eName);
      if (companyTypes && companyTypes.length > 0)
        return companyTypes[0].cName;
    }
  };
  //国际化数据来源 gBcompanyTypescName.gBcompanyTypescName.cName
  Vue.prototype.gBcompanyScalescName = function(eName) {
    if (this.$t("companyScales")) {
      var companyScales = this.$t("companyScales").filter(item => eName === item.eName)
      if (companyScales && companyScales.length > 0)
        return companyScales[0].cName;
    }
  };

  Vue.prototype.formartDegreeRequirement = function(theDegreeMin, theDegreeMax, theNinEightFive, theTwoEleven,
    theRecruitment) {
    var degreeName, name;
    if (!theDegreeMin &&
      !theDegreeMax &&
      !theNinEightFive &&
      !theTwoEleven &&
      !theRecruitment
    )
      return;

    if (theDegreeMin && !theDegreeMax) {
      degreeName = this.degreescName(theDegreeMin) + "及以上";
    } else if (!theDegreeMin && theDegreeMax) {
      degreeName = this.degreescName(theDegreeMax) + "及以下";
    } else if (theDegreeMin == theDegreeMax) {
      degreeName = this.degreescName(theDegreeMin);
    } else {
      degreeName =
        this.degreescName(theDegreeMin) +
        "~" +
        this.degreescName(theDegreeMax);
    }
    var nineEightyFive = theNinEightFive ? "  985" : "";
    var twoEleven = theTwoEleven ? "  211" : "";
    var recruitment = theRecruitment ? "  统招" : "";
    name = degreeName + nineEightyFive + twoEleven + recruitment;
    return name;
  };

  //通过languages.eName获取languages.cName
  // Vue.prototype.languagescName = function (eName) {
  //  if (this.$store.state.configData
  //    && this.$store.state.configData.languages){
  //      var languages = this.$store.state.configData.languages.filter(item => eName === item.eName)
  //      if (languages && languages.length > 0)
  //      return languages[0].cName;
  //    }
  // };
  // Vue.prototype.languagescNames = function (eNames) {
  //  if (this.$store.state.configData
  //    && this.$store.state.configData.languages) {
  //      return eNames.map(eName=>{
  //        return this.languagescName(eName)
  //      })
  //  }
  // };
  //通过languages.eName获取languages.guid
  Vue.prototype.languagesGuid = function(eName) {
    if (this.$store.state.configData &&
      this.$store.state.configData.languages) {
      var languages = this.$store.state.configData.languages.filter(item => eName === item.eName)
      if (languages && languages.length > 0)
        return languages[0].guid;
    }
  };
  Vue.prototype.languagesGuids = function(eNames) {
    if (this.$store.state.configData &&
      this.$store.state.configData.languages) {
      return eNames.map(eName => {
        return this.languagesGuid(eName)
      })
    }
  };
  //通过languages.guid获取languages.cName
  Vue.prototype.languagescName = function(guid) {
    if (this.$store.state.configData &&
      this.$store.state.configData.languages) {
      var languages = this.$store.state.configData.languages.filter(item => guid === item.guid)
      if (languages && languages.length > 0)
        return languages[0].cName;
    }
  };
  Vue.prototype.languagescNames = function(guids) {
    if (guids instanceof Array) {
      if (this.$store.state.configData &&
        this.$store.state.configData.languages) {
        return guids.map(guid => {
          return this.languagescName(guid)
        })
      }
    }

  };
  //通过companyTypes.eName获取companyTypes.cName
  Vue.prototype.companyTypescName = function(eName) {
    if (this.$store.state.configData &&
      this.$store.state.configData.companyTypes) {
      var companyTypes = this.$store.state.configData.companyTypes.filter(item => eName === item.eName)
      if (companyTypes && companyTypes.length > 0)
        return companyTypes[0].cName;
    }
  };
  //获取子级地区
  Vue.prototype.getSubRegions = function(code) {
    if (this.$store.state.configData &&
      this.$store.state.configData.regions) {
      return this.$store.state.configData.regions.filter(item => code === item.parentGuid)
    }
  };
  Vue.prototype.getHotRegion = function() {
    if (this.$store.state.configData &&
      this.$store.state.configData.regions) {
      return this.$store.state.configData.regions.filter(item => true == item.isHot)
    }
  };

  Vue.prototype.getRegion = function(code) {
    var regions = this.$store.state.configData.regions;
    return regions.filter(item => item.guid === code)[0]
  };

  //根据code获取地区所在父级城市
  Vue.prototype.getFatherCity = function(code) {
    if (this.$store.state.configData && this.$store.state.configData.regions) {
      var regions = this.$store.state.configData.regions;
      var currentRegion = regions.filter(item => item.guid === code)[0];
      var parentGuid = currentRegion.parentGuid;
      //如果没有父级,就传自己
      if (parentGuid) {
        return regions.filter(item => item.guid === parentGuid)[0];
      } else {
        return currentRegion;
      }
    }
  };

  //获取热门地区
  Vue.prototype.getHotRegions = function() {
    if (this.$store.state.configData &&
      this.$store.state.configData.regions) {
      return this.$store.state.configData.regions.filter(item => true === item.isHot)
    }
  };
  //获取子级职能
  Vue.prototype.getSubFunctions = function(code) {
    if (this.$store.state.configData &&
      this.$store.state.configData.functions) {
      return this.$store.state.configData.functions.filter(item => code === item.parentGuid)
    }
  };
  //获取子级行业
  Vue.prototype.getSubIndustries = function(code) {
    if (this.$store.state.configData &&
      this.$store.state.configData.industries) {
      return this.$store.state.configData.industries.filter(item => code === item.parentGuid)
    }
  };
  //清楚JSON对象中的null属性
  Vue.prototype.deleteEmptyProperty = function(object) {
    for (var i in object) {
      var value = object[i];
      if (value instanceof Object) {
        if (Array.isArray(value)) {
          if (value.length == 0) {
            delete object[i];
            continue;
          }
        }
        this.deleteEmptyProperty(value);
        if (this.isEmpty(value)) {
          delete object[i];
        }
      } else {
        if (value === '' || value === null || value === undefined) {
          delete object[i];
        } else {}
      }
    }
  };
  Vue.prototype.isEmpty = function(object) {
    for (var name in object) {
      return false;
    }
    return true;
  };
  Vue.prototype.modelSuccess = function(message, title) {
    var modelSuccess = {
      message: message,
      title: title,
      imgurl: 'successIcon',
    }
    return modelSuccess
  };
  Vue.prototype.modelError = function(message, title) {
    var modelError = {
      message: message,
      title: title,
      imgurl: 'failIcon',
    }
    return modelError
  };
  //弹窗 ----Boolean 显示取消按钮； Mreturn 触发取消事件
  // (num, message, Boolean, Mreturn, btnCancelTxt, btnOkTxt)
  Vue.prototype.Allmodel = function(message, title, num, Boolean, Mreturn, btnCancelTxt, btnOkTxt) {
    var Modelmeslist = {
      message: message,
      cancel: Boolean,
      Mreturn: Mreturn,
      btnCancelTxt: btnCancelTxt,
      btnOkTxt: btnOkTxt
    }
    if (num == 1) {
      this.$MsgBox["success"](Modelmeslist);
    } else if (num == 2) {
      this.$MsgBox["error"](Modelmeslist);
    } else if (num == 3) {
      this.$MsgBox["info"](Modelmeslist);
    } else if (num == 4) {
      this.$MsgBox["warning"](Modelmeslist);
    } else if (num == 5) {
      this.$MsgBox["confirm"](Modelmeslist);
    }
  };
  Vue.prototype.gotoHunterHomes = function(hunterName) {
    let routeData = this.$router.resolve({
      name: "hunterHome",
      params: {
        hunterName: hunterName
      }
    });
    window.open(routeData.href, '_blank')
  };
  Vue.prototype.gotoHunterHome = function(hunterName) {
    this.$router.push({
      name: "hunterHome",
      params: {
        hunterName: hunterName
      }
    });
  };
  Vue.prototype.workPlaceNames = function(nameString, codeString) {
    if (!codeString) return;
    else return nameString;
  };

  Vue.prototype.buildDisplayWorkplaces = function(code) {
    if (code) {
      var getRegion = (code) => {
        var regions = this.$store.state.configData.regions;
        return regions.filter(item => { return item.guid == code })[0]
      }
      var region = getRegion(code);
      if (!region) return;
      //自己就是第一级地区，直接返回地区内容
      if (!region.parentGuid) return region.name;

      if (code == '110100' || code == '120100' || code == '310100') return region.name;

      let parentGuid = region.parentGuid;
      var parent = getRegion(parentGuid);
      if (parent != null) {
        return parent.name + '・' + region.name;
      } else {
        return region.name;
      }
    }
  };

  Vue.prototype.workmyPlaceNames = function(nameString, codeString) {
    try {

      if (codeString) {
        var getRegion = (code) => {
          var regions = this.$store.state.configData.regions;
          return regions.filter(item => { return item.guid == code })[0]
        }

        var region = getRegion(codeString);
        if (region.parentGuid == null) return nameString;
        else if (codeString == '110100' || codeString == '120100' || codeString == '310100') return nameString;
        else {
          var fatherCity = this.getFatherCity(codeString);
          var str = fatherCity.guid;
          return this.regionName(str) + '・' + nameString;
        }
      } else return '无';
    } catch (err) {
      return nameString;
    }
  };

  //改变scale
  Vue.prototype.startScalejs = function(ele, notUse) {
    var standardWidth = 1920; //浏览器标准,数值越大，显示越小
    var availWidth = window.screen.width;
    var availHeight = window.screen.availHeight;
    var scale = 1;
    scale = availWidth / standardWidth
    if (scale <= 0.87) {
      scale = 0.87
    }
    if (scale >= 1) {
      scale = 1
    }
    // "zoom": scale  -- 不会缩放字体 === "transform-origin": '0 0', + "transform":scale, --- 会缩放字体

    if (notUse) {
      $(ele).css({
        "zoom": '1'
      });
    } else {
      $(ele).css({
        // "width": standardWidth,
        "zoom": scale,
        // "overflow-x": "hidden",
      });
      // $("html").height(availHeight / scale);
    }

  };
  // 数组置顶 + //置底
  Vue.prototype.swapItems = function(arr, index1, index2, direction) {
    if (direction == 'up') { //置顶
      arr.unshift(arr[index1]);
      arr.splice(index1 + 1, 1);
      return arr;
    }
    if (direction == 'down') { //置底
      arr.push(arr[index1]);
      arr.splice(index1, 1);
      return arr;
    }
    //不加 direction === 上移+下移
    arr[index1] = arr.splice(index2, 1, arr[index1])[0];
    return arr;
  };
  //财务金额千位小数格式化
  Vue.prototype.formatSalary = function(num) {
    // console.log("进来的num",num);
    num = parseFloat(num).toFixed(2).toString().split(".");
    // console.log("第一次处理后的num",num);
    num[0] = num[0].replace(new RegExp('(\\d)(?=(\\d{3})+$)', 'ig'), "$1,");
    // console.log("第一次处理后的num",num[0]);
    return num.join(".");
  };

  //财务金额千位整数数格式化
  Vue.prototype.formatIntSalary = function(num) {
    // console.log("进来的num",num);
    num = parseInt(num).toString().split(".");
    // console.log("第一次处理后的num",num);
    num[0] = num[0].replace(new RegExp('(\\d)(?=(\\d{3})+$)', 'ig'), "$1,");
    // console.log("第一次处理后的num",num[0]);
    return num.join(".");
  };

  //隐藏手机号码
  Vue.prototype.hide_mobile = function(str1) {
    var reg = /^(\d{3})\d*(\d{4})$/;
    if (str1) return str2 = str1.replace(reg, '$1****$2')
  };
  //隐藏邮箱
  Vue.prototype.hide_email = function(str1) {
    var reg = /(.{1}).*(@.+)/;
    if (str1) return str2 = str1.replace(reg, '$1****$2')
  };
  //**************************************** 职聊日期节点*****************************/
  Vue.prototype.formatDayTime = function(date) {
    if (date) {
      return new Date(date).format("hh:mm:ss");
    }
  };
  // 刚刚、几分钟前、hh:mm:ss、星期几、yyyy-MM-dd hh:mm:ss
  Vue.prototype.handleDate = function(dateTimeStamp) {
    var minute = 1000 * 60;
    var hour = minute * 60;
    var day = hour * 24;
    var result = '';
    var now = new Date().getTime();
    var z_now = new Date(this.formatDate(now)).getTime()
    var week = this.getWeekNumber(dateTimeStamp)
    var weekNow = this.getWeekNumber(now)
    var diffValue = now - dateTimeStamp;
    if (diffValue < 0) {
      // console.log("时间不对劲,服务器创建时间与当前时间不同步");
      return result = "刚刚";
    }
    var dayC = diffValue / day;
    var hourC = diffValue / hour;
    var minC = diffValue / minute;
    if (dayC > 30) {
      return result = "" + this.formatDateTime(dateTimeStamp);
    } else if (dayC >= 1 || z_now > dateTimeStamp) {
      // 星期几
      if (weekNow == week) {
        return result = "" + this.getMyDay(dateTimeStamp) + '  ' + this.formatDayTime(dateTimeStamp);
      } else {
        return result = "" + this.formatDateTime(dateTimeStamp);
      }
    } else if (hourC >= 1) {
      return result = "" + this.formatDayTime(dateTimeStamp);
    } else if (minC >= 5) {
      return result = "" + parseInt(minC) + "分钟前";
    } else
      return result = "刚刚";
  };
  /**
   * 判断年份是否为润年
   *
   * @param {Number} year
   */
  Vue.prototype.isLeapYear = function(year) {
    return (year % 400 == 0) || (year % 4 == 0 && year % 100 != 0);
  }
  /**
   * 获取某一年份的某一月份的天数
   *
   * @param {Number} year
   * @param {Number} month
   */
  Vue.prototype.getMonthDays = function(year, month) {
    return [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month] || (this.isLeapYear(year) ? 29 : 28);
  }
  /**
   * 获取某年的某天是第几周
   * @param {Number} y
   * @param {Number} m
   * @param {Number} d
   * @returns {Number}
   */
  Vue.prototype.getWeekNumber = function(dateTimeStamp) {
    var now = new Date(dateTimeStamp),
      year = now.getFullYear(),
      month = now.getMonth(),
      days = now.getDate();
    //那一天是那一年中的第多少天
    for (var i = 0; i < month; i++) {
      days += this.getMonthDays(year, i);
    }
    //那一年第一天是星期几
    var yearFirstDay = new Date(year, 0, 1).getDay() || 7;

    var week = null;
    if (yearFirstDay == 1) {
      week = Math.ceil(days / yearFirstDay);
    } else {
      days -= (7 - yearFirstDay + 1);
      week = Math.ceil(days / 7) + 1;
    }
    return week;
  };
  //星期几
  Vue.prototype.getMyDay = function(date) {
    var weekDay;
    if (new Date(date).getDay() == 0) weekDay = "星期日"
    if (new Date(date).getDay() == 1) weekDay = "星期一"
    if (new Date(date).getDay() == 2) weekDay = "星期二"
    if (new Date(date).getDay() == 3) weekDay = "星期三"
    if (new Date(date).getDay() == 4) weekDay = "星期四"
    if (new Date(date).getDay() == 5) weekDay = "星期五"
    if (new Date(date).getDay() == 6) weekDay = "星期六"
    return weekDay;
  }
  //**************************************** 职聊日期节点*****************************/

  //检查中英文输入字数
  Vue.prototype.fnGetCpmisWords = function(str) {
    sLen = 0;
    try {
      //先将回车换行符做特殊处理
      str = str.replace(/(\r\n+|\s+|　+)/g, "龘");
      //处理英文字符数字，连续字母、数字、英文符号视为一个单词
      str = str.replace(/[\x00-\xff]/g, "m");
      //合并字符m，连续字母、数字、英文符号视为一个单词
      str = str.replace(/m+/g, "*");
      //去掉回车换行符
      str = str.replace(/龘+/g, "");
      //返回字数
      sLen = str.length;
    } catch (e) {

    }
    return sLen;
  };
  Vue.prototype.toTop = function() {
    window.scrollTo(0, 0);
  };
  // 计算数组中值的出现次数
  Vue.prototype.countOccurrences = function(arr, val) {
    return arr.reduce((a, v) => (v === val ? a + 1 : a + 0), 0);
  };
  //省略号---；num--字数；Tag-- 元素
  Vue.prototype.mitulineHide = function(Tag, num) {
    var contain = document.getElementsByClassName(Tag)
    for (var i = 0; i < contain.length; i++) {
      var txt = contain[i].innerHTML;
      if (txt.length > num) {
        txt = txt.substring(0, num - 1) + "...";
        contain[i].innerHTML = txt;
      } else {
        // console.log("ellipsis:error")
      }
    }
  };
  //省略号---；num--字数；txt-- 文本
  Vue.prototype.mitulinetxtHide = function(txt, num) {
    if (txt.length > num) {
      txt = txt.substring(0, num - 1) + "...";
    } else {
      // console.log("ellipsis:error")
    }
    return txt;
  };
  //根据positionId跳转到该职位的详情页
  Vue.prototype.gotoPositionDetail = function(item) {
    this.$api.oj.getMyOperation(item.positionId, data => {
      if (data.status == '200') {
        let routeData = this.$router.resolve({
          name: "positionDetail",
          query: {
            positionId: item.positionId
          }
        });
        window.open(routeData.href, '_blank');
      } else {
        this.error(data.message);
      }
    });
  };
  //根据positionId跳转到该职位的详情页,企业直招
  Vue.prototype.gotoCompanyPositionDetail = function(item) {
    this.$api.oj.getCompanyMyOperation(item.positionId, data => {
      if (data.status == '200') {
        let routeData = this.$router.resolve({
          name: "companyPositionDetail",
          query: {
            positionId: item.positionId
          }
        });
        window.open(routeData.href, '_blank');
      } else {
        this.error(data.message);
      }
    });
  };
  //省略号---；num--字数；txt-- 文本
  Vue.prototype.efmitulinetxtHide = function(txt, num) {
    if (txt && txt.length > num) {
      txt = txt.substring(0, num - 1) + "...";
    } else {
      // console.log("ellipsis:error")
    }
    return txt;
  };
};
